import { GraduationCap, TvMinimalPlay, BookOpen, FileText, Podcast, Wind } from 'lucide-react';
import { type WellbeingTypeConfig } from 'types/wellbeing';

export enum WellbeingTypes {
  trainings = 'trainings',
  tips = 'tips',
  ebooks = 'ebooks',
  articles = 'articles',
  podcasts = 'podcasts',
  exercises = 'exercises',
}

export const WELLBEING_CONFIG: Record<WellbeingTypes, WellbeingTypeConfig> = {
  [WellbeingTypes.trainings]: {
    id: WellbeingTypes.trainings,
    key: 'trainings',
    apiPath: 'trainings',
    icon: GraduationCap,
    color: 'bg-mint-300 text-teal-700',
  },
  [WellbeingTypes.tips]: {
    id: WellbeingTypes.tips,
    key: 'tips',
    apiPath: 'tips',
    icon: TvMinimalPlay,
    color: 'bg-plum-200 text-plum-500',
  },
  [WellbeingTypes.ebooks]: {
    id: WellbeingTypes.ebooks,
    key: 'ebooks',
    apiPath: 'ebooks',
    icon: BookOpen,
    color: 'bg-mint-300 text-teal-700',
  },
  [WellbeingTypes.articles]: {
    id: WellbeingTypes.articles,
    key: 'articles',
    apiPath: 'articles',
    icon: FileText,
    color: 'bg-mint-300 text-teal-700',
  },
  [WellbeingTypes.podcasts]: {
    id: WellbeingTypes.podcasts,
    key: 'podcasts',
    apiPath: 'podcasts',
    icon: Podcast,
    color: 'bg-mint-300 text-teal-700',
  },
  [WellbeingTypes.exercises]: {
    id: WellbeingTypes.exercises,
    key: 'exercises',
    apiPath: 'exercises',
    icon: Wind,
    color: 'bg-mint-300 text-teal-700',
  },
};
